import nav from "../navbar/locals/en.json";
import footer from "../footer/locals/en.json";
import sidebar from "../sidebar/locals/en.json";

export default {
  nav,
  footer,
  sidebar,
};
